

import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import eChart from "./configs/eChart";
import { useEffect, useRef } from "react";

const EChart = ({options, series}) => {
  const { Title, Paragraph } = Typography;
  const chartRef = useRef();

  useEffect(() => {
    if (chartRef.current && options && series) {
      // Cập nhật options và series cho biểu đồ
      chartRef.current.chart.updateOptions(options, false, true);
      chartRef.current.chart.updateSeries(series);
    }
  }, [options, series]);
  return (
    <>
      <div id="chart">
        <ReactApexChart
          ref={chartRef}
          className="bar-chart"
          options={eChart.options}
          series={eChart.series}
          type="line"
          height={400}
        />
      </div>
      <div className="chart-vistior">
        <Title level={5}>Biểu đồ thống kê doanh thu theo ngày</Title>
        <Paragraph className="lastweek">
          Thống kê và phân loại doanh thu theo ngày
        </Paragraph>
      </div>
    </>
  );
}

export default EChart;
